import { IconUpload } from '@tabler/icons-react';
import styles from './empty-content-state.module.css';
import ButtonComponent from '../../../common/button-component/button-component';

interface EmptyContentStateProps {
  title: string;
  description: string;
  showUploadButton?: boolean;
  onUploadClick?: () => void;
}

export default function EmptyContentState({
  title,
  description,
  showUploadButton = false,
  onUploadClick,
}: EmptyContentStateProps) {
  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyStateIcon}>
        <span className={styles.emoji}>💿</span>
      </div>
      <h3>{title}</h3>
      <p className={styles.emptyStateDescription}>{description}</p>
      {showUploadButton && (
        <ButtonComponent type="button" onClick={onUploadClick} aria-label="Upload Content" variant="primary">
          <IconUpload size={20} />
          <span>Upload Content</span>
        </ButtonComponent>
      )}
    </div>
  );
}
